"use client";
import { Container, Box, AppBar } from "@mui/material";
import SortOptions from "@/components/comments/SortOptions";
import CommentList from "@/components/comments/CommentList";
import CommentInput from "@/components/comments/CommentInput";
import { useCommentsStore } from "@/stores/commentsStore";
import { useEffect } from "react";
import { IUsers } from "@/types";

interface CommentsContainerProps {
  lang: string;
  debateId: string;
  debateUser: IUsers;
}

export default function CommentsContainer({ lang, debateId, debateUser }: CommentsContainerProps) {
  return (
    <Container sx={{ py: 2 }}>
      <SortOptions />
      <Box>
        <CommentList lang={lang} debateId={debateId} debateUser={debateUser} />
      </Box>
      <CommentInput lang={lang} debateId={debateId} />
    </Container>
  );
}
